// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"c51f0ea9","376":"b80ae4f2","622":"f92694bd","896":"1a069224"}[chunkId] + ".chunk.css";
};